import { Link } from "react-router-dom";
import React from "react";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    id: "daily-meals",
    num: "01",
    title: "Daily Corporate Meals",
    blurb:
      "Chef-curated breakfast, lunch and snack programmes for offices of 50 to 5,000. Rotating 28-day menus with Jain, vegan and keto tracks.",
    image:"/images/daily meals.webp",
     path: "/daily-corporate-meals", 
},
  {
    id: "event-catering",
    num: "02",
    title: "Event Catering",
    blurb:
      "Award nights, soirée parties, conferences and gala dinners — end-to-end menu design, live stations, service staff and bar partners.",
    image:"/images/event catering.webp",
    path: "/event-catering",  
 },
  {
    id: "meeting-bento",
    num: "03",
    title: "Packed Bento Boxes",
    blurb:
      "Individually packed, portion-controlled meal trays with multiple compartments — perfect for board meetings, training sessions and travel days.",
    image:"/images/bento box.webp",
    badge: "Custom-branded packaging available",
    path: "/bento-boxes",  
},
  {
    id: "pantry",
    num: "04",
    title: "Pantry Management",
    blurb:
      "Fully staffed, stocked and audited pantries with barista-grade coffee, artisanal teas, healthy snacks and SLA-backed replenishment.",
    image:"/images/pantry.webp",
    path: "/pantry-management", 
 },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-28 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-16 md:mb-24">
          <div className="max-w-2xl">
            <p className="label-eyebrow">03 · What We Do</p>
            <h2 className="font-serif text-[#1E3A5F] mt-5 text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
              Workplace food services.
              <span className="italic text-[#CBA365]"> One partner.</span>
            </h2>
          </div>
          <p className="text-[#1E3A5F]/70 font-light max-w-sm text-base leading-relaxed">
            Daily office meals, corporate event catering, packed meal boxes and pantry management — planned around your team, schedule and workplace.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
          {SERVICES.map((s, i) => (
            <Link
              to={s.path}
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className={`group relative ${i % 2 === 1 ? "md:mt-24" : ""}`}
            >
              <div className="relative aspect-[5/4] overflow-hidden bg-[#E8DDCB]">
                <img
                  src={s.image}
                  alt={s.title}
                  width="400"
                  height="320"
                  className="absolute inset-0 w-full h-full object-cover will-change-transform transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-5 left-5 bg-[#FDFBF7] text-[#1E3A5F] text-[10px] uppercase tracking-[0.25em] px-3 py-1.5">
                  {s.num}
                </div>
                {s.badge && (
                  <div
                    data-testid={`service-badge-${s.id}`}
                    className="absolute top-5 right-5 bg-[#CBA365] text-[#1E3A5F] text-[10px] uppercase tracking-[0.22em] px-3 py-1.5 font-medium shadow-sm"
                  >
                    {s.badge}
                  </div>
                )}
              </div>
              <div className="pt-6 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl text-[#1E3A5F]">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[#1E3A5F]/70 font-light text-[15px] leading-relaxed max-w-md">
                    {s.blurb}
                  </p>
                </div>
                <Link
                  to={s.path}
                  aria-label={`Enquire about ${s.title}`}
                  data-testid={`service-cta-${s.id}`}
                  className="shrink-0 mt-1 inline-flex items-center justify-center w-12 h-12 border border-[#1E3A5F]/30 text-[#1E3A5F] hover:bg-[#1E3A5F] hover:text-[#FDFBF7] transition-all duration-300"
                >
                  <ArrowUpRight size={18} />
                </Link>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
